/* 
Index.js
App file that renders react components <Tree> and <Mobilemessage>
*/

import React from "react";
import { render } from "react-dom";
import Tree from "./Tree";
import data from "./data/NodeData";
import "./index.css";

const App = () => (
  <div className="app-container">
    <Tree data={data} width={1900} height={935} />
    {/* <Mobilemessage/> */}
  </div>
);

render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js